import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Badge, IconButton, Snackbar } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AccountMenu from './AccountMenu';
import './AppMenuBar.scss';

const AppMenuBar = ({ onLeaveRoomClick, onLogoutClick, onGameInfoClick, roomId, isHost, hasRoomMembership, isRandomRoom = false,
    onSwapPositionsClick, onSupportClick, onChatClick, onInviteClick, onSettingClick, newMessageCount,
    toggleFullScreen, isFullScreen, leadingTopBarControls, topBarControls, menuControl, isLobby = false }) => {
    const { t } = useTranslation();
    const [copyMessage, setCopyMessage] = useState('');
    const copyRoomId = async () => {
        if (!roomId || isRandomRoom) return;
        try {
            if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(roomId);
            else {
                const field = document.createElement('textarea');
                field.value = roomId; field.style.position = 'fixed'; field.style.opacity = '0';
                document.body.appendChild(field);
                try { field.select(); if (!document.execCommand('copy')) throw new Error('COPY_FAILED'); }
                finally { field.remove(); }
            }
            setCopyMessage(t('menuBar.roomIdCopied'));
        } catch { setCopyMessage(t('menuBar.copyFailed')); }
    };
    const roomActions = hasRoomMembership ? [
        ...(onSettingClick ? [{ label: 'menuBar.gameRules', onClick: onSettingClick }] : []),
        { label: 'menuBar.roomInfo', onClick: onGameInfoClick },
        { label: 'menuBar.swapPositions', onClick: onSwapPositionsClick },
        ...(!isRandomRoom ? [{ label: 'menuBar.invite', onClick: onInviteClick }] : []),
        { label: 'menuBar.reload', onClick: () => window.location.reload() },
        { label: isFullScreen ? 'menuBar.exitFullScreen' : 'menuBar.fullScreen', onClick: toggleFullScreen },
        { label: 'menuBar.feedbackSupport', onClick: onSupportClick },
        { label: 'menuBar.leaveRoom', onClick: onLeaveRoomClick, icon: <MeetingRoomIcon /> },
    ].filter(action => action.onClick) : [];
    const isRoomBar = Boolean(roomId || hasRoomMembership);
    return <header className="menu-bar-container">
        <div className={`menu-bar${menuControl ? ' menu-bar--language' : ''}`}>
            <div className="icon chat-icon">
                {!isRoomBar && <Link className="toolbar-brand" to="/">GaSarMal</Link>}
                {hasRoomMembership && <IconButton size="large" color="inherit" aria-label={t('chat.title')} onClick={onChatClick}>
                    <Badge badgeContent={newMessageCount} max={10} color="error"><MailIcon /></Badge>
                </IconButton>}
            </div>
            {isRoomBar ? <div className="room-status-controls">
                {leadingTopBarControls && <div className="top-bar-controls">{leadingTopBarControls}</div>}
                <button type="button" className="room-id" onClick={copyRoomId} disabled={isRandomRoom || !roomId}
                    title={isRandomRoom ? t('roomEntry.randomRoom') : t('menuBar.copyRoomId')}>
                    <span>{isRandomRoom ? t('roomEntry.randomRoom') : t('menuBar.roomId', { roomId: roomId || '' })}</span>
                </button>
                <div className="top-bar-controls">{topBarControls}</div>
            </div> : <div className="toolbar-spacer" aria-hidden="true" />}
            <div className={`icon menu-icon${menuControl ? ' toolbar-language' : ''}`}>{menuControl || <AccountMenu roomActions={roomActions} onLogoutClick={onLogoutClick} roomId={roomId} isLobby={isLobby} />}</div>
        </div>
        <Snackbar open={!!copyMessage} message={copyMessage} autoHideDuration={2500} onClose={() => setCopyMessage('')}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{ top: '50% !important', left: '50% !important', right: 'auto !important', transform: 'translate(-50%, -50%)' }} />
    </header>;
};
export default AppMenuBar;
